import type { AuthUser } from 'common/auth/types';

export type TargetUser = { type: 'username'; value: string } | { type: 'userPk'; value: string };

export function isTargetUser(user: AuthUser | null, target: TargetUser | null): boolean {
    if (!user || !target) {
        return false;
    }

    return target.type === 'username' ? user.username === target.value : user.pk === target.value;
}
